'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import emAction from '../../actions/emAction';

class EstateList extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }
    static defaultProps = {
        mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        dayTxt: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        statusTxt: ["OK", "Not Ok", "Resolved"],
    };

    handleClick(e) {
        let index = parseInt(e.currentTarget.getAttribute("data-index"));
        index = index + this.props.page * this.props.contentNo;
        emAction.shouldListShow(index);
    }
    renderDataList(est, index) {
        est.date = new Date(est.date);
        est.time = new Date(est.time);
        let date = est.date.getDate() + "-" + this.props.mthTxt[est.date.getMonth()] + "-" + est.date.getFullYear();
        let day = this.props.dayTxt[est.date.getDay()];
        let timeInHour = (est.time.getHours() < 10 ? "0" + est.time.getHours() : est.time.getHours());
        let timeInMinute = (est.time.getMinutes() < 10 ? "0" + est.time.getMinutes() : est.time.getMinutes());
        let time = timeInHour + ":" + timeInMinute;
        return (
            <tr key={index}>
                <td>{est.condoName}</td>
                <td>{est.mcst}</td>
                <td>{est.userName}</td>
                <td>{date}</td>
                <td>{day}</td>
                <td>{time}</td>
                <td>{est.facility}</td>
                <td>{est.category}</td>
                <td>{this.props.statusTxt[est.status]}</td>
                <td>{this.renderReportNo(est)}</td>
            </tr>
        )
    }
    renderReportNo(est) {
        if (!Array.isArray(est.reportNo)) {
            return (<Link to={"/report/" + est.reportNo}>{est.reportNo}</Link>);
        }else{
            return est.reportNo.map((reportNo,index)=>{
                return (<div key={index}><Link to={"/report/" + reportNo}>{reportNo}</Link></div>);
            });
        }
    }
    renderDataLists(est, index) {
        let body = est.estate.map((est1, index1) => {
            return (this.renderDataList(est1, index1));
        });

        return (
            <table className={"est-tb " + (est.shouldListShow ? "est-show" : "est-hide")}>
                <tbody className="est-tbd">
                    {body}
                </tbody>
            </table>
        );
    }
    renderNameList(est, index) {
        return (
            <div className="est-a-nlw" onClick={this.handleClick} data-index={index} style={{ width: this.props.tableWidth + "px" }}>
                <i className={"est-a-nli " + (est.shouldListShow ? "glyphicon glyphicon-minus" : "glyphicon glyphicon-plus")}></i>
                <div className="est-a-nl est-a-n">{est.condoName} ({est.mcst})<span className="badge">{est.incident}</span></div>
            </div>
        );
    }
    renderMainList() {
        return this.props.estate.map((est, index) => {
            return (
                <div key={index}>
                    {this.renderNameList(est, index)}
                    {this.renderDataLists(est, index)}
                </div>
            );
        });
    }
    render() {
        return (
            <div className="atd-abd-wp">
                <div className="atd-em-lt">
                    {this.renderMainList()}
                </div>
            </div>
        );
    }
}
export default EstateList;


// WEBPACK FOOTER //
// ./app/components/emComponents/estateList.js